import { ComponentCreateRequestStatusCode } from '@gql/graphql';

export function getActionDialogName(
    code: ComponentCreateRequestStatusCode,
): string {
    switch (code) {
        case ComponentCreateRequestStatusCode.Approved:
            return 'Approve';
        case ComponentCreateRequestStatusCode.Forwarded:
            return 'Forward';
        case ComponentCreateRequestStatusCode.Removed:
            return 'Remove';
        case ComponentCreateRequestStatusCode.Replaced:
            return 'Replace';
        default:
            throw Error('Action not supported');
    }
}
